<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Grid.scss";

  .container-control{
    border: 4px solid #dcdcdc;
    margin: auto;
    height: 130px;
    padding: 15px;
    text-align: center;
    width: 130px;
  }

  .container-alerts{
    width: 130px;
  }

  .container-card{
    width: 150px;
  }

  .alert-float{
    left: -3px;
    position: absolute;
    top:-1px;
  }

  .grid-view-item:hover{
    cursor: pointer;
    background-color: #eeee;
  }

  .inactive{
    background-color: #eeee;
  }

  .vx-card__body{
    padding: 7px!important;
  }
</style>
<template>
  <div>
    <div class="vx-row px-2 py-5">
      <div class="vx-col ">
        <label  class="font-bold">{{$tc('Labels.TankLevel',0)}}</label>
        <vs-slider v-model="filters.level_tank"/>
      </div>
      <div class="vx-col">
        <vs-checkbox v-model="filterLastCharge" class="inline-block"></vs-checkbox>
        <label class="font-bold">{{$t('Labels.LastCharge')}}</label>
        <datepicker :value="filters.recharge_at" format="dd-MM-yyyy" :disabled="!filterLastCharge"></datepicker>
      </div>
      <div class="vx-col">
        <label class="font-bold">{{$t('Labels.ClientNumber')}}</label>
        <vs-input class="w-full" v-model="filters.client_number" />
      </div>
      <div class="vx-col">
        <vs-button @click="getResponse()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5">
      <div class="vx-col">
        <label  class="font-bold">{{$t('Labels.Capacity')}}</label>
        <vs-slider v-model="filters.capacity"/>
      </div>
      <div class="vx-col">
        <vs-checkbox v-model="filterLastSeen" class="inline-block"></vs-checkbox>
        <label class="font-bold">{{$t('Labels.LastSeen')}}</label>
        <datepicker :value="filters.last_seen" format="dd-MM-yyyy" :disabled="!filterLastSeen"></datepicker>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Serie')}}</label>
        <vs-input class="w-full" v-model="filters.serie" />
      </div>
      <div class="vx-col">
        <label  class="font-bold">{{$t('Labels.BatteryLevel')}}</label>
        <vs-slider v-model="filters.battery"/>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="byColumn" :reduce="v => v.value"/>
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>   
      </div>
    </div>
    <div class="text-center py-6">{{$t('Labels.NoData')}}</div>
    <div class="grid-container">
      <div class="vx-row match-height mt-4">
        <div :key="item.objectID" @click="goToDetail(item.uuid)" class="vx-col lg:w-1/6 sm:w-1/2 w-full" v-for="item in response">
            <vx-card class="grid-view-item mb-base overflow-hidden py-2" :class="{'inactive': !item.updatedAt }">
              <div class="container-control rounded-full mb-2 relative">
                <statusItem class="alert-float" :status="item.updatedAt.length > 0 ? getStatus(item.percent) : 'grey'"/>
                <div class="text-xs">{{$t('Labels.Capacity')}}</div>
                <div class="text-xl font-bold mb-2">{{item.percent}}%</div>
                <vs-divider class="my-2 mx-0" border-style="dashed" color="dark"/> 
                <div class="text-xl font-bold">{{item.capacity}}L</div>
                <div class="text-xs">{{$t('Labels.Liters')}}</div>
              </div>
              <div class="text-xs text-center">{{$t('Labels.ClientNumber')}}</div>
              <div class="text-center mb-1">{{item.updatedAt.length > 0 ? item.client_number : 'N/A'}}</div>
              <div class="container-alerts text-center m-auto mb-1">
                <icon-signal-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="getSignalPercent(item.rssi)" /> <span class="align-middle">{{getSignalPercent(item.rssi)}}%</span>
                <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(item.battery)" /> <span class="align-middle">{{item.battery}}%</span>
              </div>
              <vx-tooltip :text="item.updatedAt || $t('Labels.Inactive')" class="text-center">
                <div class=" text-center text-xs">{{item.updatedAt.length > 0 ? relativeTimeConvert(item.updatedAt) : $t('Labels.Inactive')}}</div>
              </vx-tooltip>
            </vx-card>
        </div>
      </div>
       <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
    </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import statusItem from '@/components/statusItem/statusItem.vue'
import iconBatteryPercent from '@/components/icons/iconBatteryPercent'
import Datepicker from 'vuejs-datepicker'
import iconSignalPercent from '@/components/icons/iconSignalPercent'
import {getSignalPercent, getStatusByPercent, formatDate, empty} from '@/helpers.js'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'

export default {
  components: {
    statusItem,
    iconBatteryPercent,
    Datepicker,
    iconSignalPercent,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      selected:[],
      filters:{
        limit: 25,
        offset: 0,
        byColumn: 'updatedAt',
        byOrder: 'ASC',
        serie:null,
        client_number: null,
        level_tank: [null, null],
        battery: [null, null],
        capacity: [null, null],
        last_seen: new Date(),
        recharge_at: new Date()
      },
      filterLastCharge: false,
      filterLastSeen: false,
      columnOrders:[
        {label: this.$tc('Labels.TankLevel', 1), value: 'percent'},
        {label: this.$t('Labels.ClientNumber'), value: 'client_number'},
        {label: this.$t('Labels.Battery'), value: 'battery'},
        {label: this.$t('Labels.LastCharge'), value: 'recharge_at'},
        {label: this.$t('Labels.LastSeen'), value: 'updatedAt'}
      ],
      byColumn: 'updatedAt'
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const filter = {}
      filter.begin_battery = this.filters.battery[0]
      filter.end_battery = this.filters.battery[1]
      if (this.filters.battery[1] !== null && this.filters.battery[0] === null) filter.begin_battery = 0
      filter.begin_percent = this.filters.level_tank[0]
      filter.end_percent = this.filters.level_tank[1]
      if (this.filters.level_tank[1] !== null && this.filters.level_tank[0] === null) filter.begin_percent = 0
      filter.begin_capacity = this.filters.capacity[0]
      filter.end_capacity = this.filters.capacity[1]
      if (this.filters.capacity[1] !== null && this.filters.capacity[0] === null) filter.begin_capacity = 0
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder
      filter.serie = this.filters.serie
      filter.client_number = this.filters.client_number
      
      if (this.filterLastCharge) filter.recharge_at = formatDate(this.filters.recharge_at)
      
      if (this.filterLastSeen) filter.last_seen = formatDate(this.filters.last_seen)

      const params = {
        url: 'gas_devices',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.setPages(response.data.data.count)
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
      })
      
    },
    resetFilters () {
      this.filters.serie = null
      this.filters.no_client = null
      this.filters.level_tank = [null, null]
      this.filters.battery = [null, null]
      this.filters.capacity = [null, null]
      this.filters.last_seen = new Date()
      this.filters.recharge_at = new Date()
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    getStatus (percent) {
      return getStatusByPercent(percent)
    },
    getLiters (percent, capacity) {
      return (capacity * (percent / 100)).toFixed(2)
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    goToDetail (uuid) {
      if (!empty(uuid)) window.location.href = `/gas/${uuid}`
    },
    getSignalPercent (value) {
      return getSignalPercent(value)
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    }
  },
  sockets: {
    gas (payload) {
      this.response.forEach(toModify => {
        if (toModify.deveui === payload.deveui) {
          toModify.rssi = payload.rssi
          toModify.battery = payload.battery
          toModify.percent = payload.percent
          toModify.updatedAt = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>